import { Link } from "react-router-dom"

const Error = () => {
    return (
        <div>
            <h1>Error 404</h1>
            <h2>Page not found</h2>
            <p><Link to="/">Link to homepage</Link></p>
        </div>
    )
}

export default Error